'use client';

import { useEffect, useState } from 'react';

function elapsedSecondsSince(startedAt: number): number {
  return Math.max(0, Math.floor((Date.now() - startedAt) / 1000));
}

export function useEnglishIqElapsedSeconds(startedAt: number): number {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    const updateElapsedSeconds = (): void => setElapsedSeconds(elapsedSecondsSince(startedAt));
    updateElapsedSeconds();
    const timer = window.setInterval(updateElapsedSeconds, 1000);
    return () => window.clearInterval(timer);
  }, [startedAt]);

  return elapsedSeconds;
}
